import { Employee, EmployeeDisplayShortInfo } from '../types'

export const getEmployeeFullName = (employee: Employee | undefined | null): string => {
  if (!!employee) {
    const hasChosenName = !!employee.chosenFirstName && !!employee.chosenLastName
    if (hasChosenName) {
      return `${employee.chosenFirstName} ${employee.chosenLastName}`
    }
    return `${employee.legalFirstName || '-'} ${employee.legalLastName || '-'}`
  }

  return '-'
}

export const getReviewerFullName = (employee: EmployeeDisplayShortInfo | undefined | null): string => {
  if (!!employee) {
    return `${employee.firstName || '-'} ${employee.lastName || '-'}`
  }
  return '-'
}

export const getEmployeeFirstName = (employee: Employee | undefined | null): string => {
  if (!!employee) {
    return !!employee.chosenFirstName ? employee.chosenFirstName : `${employee.legalFirstName || '-'}`
  }

  return '-'
}

export const getEmployeeUserName = (email: string | undefined | null): string => {
  return !!email ? email.split('@')[0] : '-'
}
